module.exports = __webpack_public_path__ + "img/website.fd45da6b.svg";